import { render, staticRenderFns } from "./YouSuitablePage.vue?vue&type=template&id=ba107702&scoped=true&"
import script from "./YouSuitablePage.vue?vue&type=script&lang=js&"
export * from "./YouSuitablePage.vue?vue&type=script&lang=js&"
import style0 from "./YouSuitablePage.vue?vue&type=style&index=0&id=ba107702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba107702",
  null
  
)

export default component.exports